export default () => ({
  tourTypes: [],
});
